// Roles --
// GENERAL_ROLE: 1,
// SYSTEMADMIN_ROLE: 2,
// ITMANAGER_ROLE: 3,
// HRMANAGER_ROLE: 4,
// HRADMIN_ROLE: 5, 14,
// SAFETYTESTING_ROLE: 6,
// HRMANAGERSAFETY_ROLE: 7,
// ITHRMANAGER : 8,
// Loco Admin:9,
//Loco manager :l0,
// Mechanic :'11',
// DSLE : '12',
// HRSUPERADMIN: 14


const roleManager = (component, innerComponent = false, subInnerComponent = false,) => {
    const userProfile = JSON.parse(localStorage.getItem("user_profile"));
    if (userProfile) {
        var { role_id, id, PositionLevelId } = userProfile;
    }
    let capabilities = {
        sidebar: {
            dashboard:
            {
                role_id: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19],
                position_lvl_id: [],
                id: []

            },

            safety: {
                role_id: [2, 6, 7, 9, 10, 12, 13, 15, 16, 19],
                position_lvl_id: [],
                id: []
            },
            create_ticket: {
                role_id: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19],
                position_lvl_id: [],
                id: []
            },
            fuel_management: {
                role_id: [2, 9],
            },
            deparment: {
                role_id: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19],
                position_lvl_id: [],
                id: []
            },
            new_hire_queue: {
                role_id: [2, 4, 18, 5, 14],
                position_lvl_id: [],
                id: []
            },
            new_hire_queue_it: {
                role_id: [2, 3, 8],
                position_lvl_id: [],
                id: []
            },
            tickets_alerts: {
                role_id: [2, 3, 4, 18, 5, 14, 8],
                position_lvl_id: [],
                id: []
            },
            employees: {
                role_id: [2, 4, 5, 18, 14, 7, 8, 13, 16, 17],
                position_lvl_id: [],
                id: []
            },
            broadcast_message: {
                role_id: [2],
                position_lvl_id: [],
                id: []
            },
            employees_profile: {
                role_id: [2, 4, 18, 7, 8],
                position_lvl_id: [],
                id: []
            },
            hardware: {
                role_id: [2, 3, 8],
                position_lvl_id: [],
                id: []
            },
            equipmentLookup: {
                role_id: [2, 12],
                position_lvl_id: [1, 3],
                id: []
            },

            locomotiveMain: {
                role_id: [2, 9, 10, 11, 12],
                position_lvl_id: [],
                id: []
            },

            locomotive: {
                role_id: [2, 9, 10, 11],
                position_lvl_id: [],
                id: []
            },
            locomotiveTicket: {
                role_id: [2, 9, 10, 12],
                position_lvl_id: [],
                id: []
            },
            locomotiveWorkOrder: {
                role_id: [2, 9, 10, 11],
                position_lvl_id: [],
                id: []
            },
            systemAdmin: {
                role_id: [2],
                position_lvl_id: [],
                id: []
            },
            payroll: {
                role_id: [17],
                position_lvl_id: [],
                id: []
            },
            pending_payroll: {
                role_id: [1, 2, 3, 4, 5, 14, 6, 7, 8, 9, 10, 11, 12, 13, 15, 16],
                position_lvl_id: [],
                id: []
            }
        },
        LocomotiveWorkOrder: {
            sections: {
                ApproveORreject: {
                    role_id: [9, 2],
                    position_lvl_id: [],
                    id: []
                },
                DeleteListSheet: {
                    role_id: [9, 2],
                    position_lvl_id: [],
                    id: []
                },
                LocoMechanic: {
                    role_id: [11],
                    position_lvl_id: [],
                    id: []
                },
                TicketCategory: {
                    role_id: [2, 9],
                    position_lvl_id: [],
                    id: []
                },
                work_order_edits: {
                    role_id: [2, 9, 10],
                },
            },
        },
        employeeLookup: {
            sections: {
                PayDetails: {
                    role_id: [5, 14],
                    position_lvl_id: [],
                    // id: [10028, 10027, 10411, 20036]
                    id: []
                },
                ShowHide: {
                    role_id: [9, 10, 2],
                    position_lvl_id: [],
                    id: []
                },
                PayDetailsTable: {
                    role_id: [5, 14, 13],
                    position_lvl_id: [],
                    // id: [10028, 10027, 10411, 20036]
                    id: []
                },
                terminationDate: {
                    role_id: [2, 5, 14],
                    position_lvl_id: [],
                    id: []
                },
                position: {
                    role_id: [2, 5, 14, 13, 17],
                    position_lvl_id: [],
                    id: []
                },
                closeWorkOrder: {
                    role_id: [2, 9, 10],
                    position_lvl_id: [],
                    id: []
                },
                changePassword: {
                    role_id: [2, 14]
                },
                positionButton: {
                    role_id: [2, 5, 14],
                    position_lvl_id: [],
                    id: []
                },
                showDocuments: {
                    role_id: [2, 5, 14, 13, 17],
                    position_lvl_id: [],
                    id: []
                },
                attachments: {
                    role_id: [2, 5, 14],
                    position_lvl_id: [],
                    id: []
                },
                questionare: {
                    role_id: [2, 4, 18, 5, 14],
                    position_lvl_id: [],
                    id: []
                },
                EmployeeId: {
                    role_id: [2, 4, 18, 5, 14, 17],
                    position_lvl_id: [],
                    id: []
                },
                EmployeeIdEdit: {
                    role_id: [2, 4, 5, 14, 17],
                    position_lvl_id: [],
                    id: []
                },
                dateOfBirth: {
                    role_id: [2, 4, 18, 5, 14, 17],
                    position_lvl_id: [],
                    id: []
                },
                Status: {
                    role_id: [2, 4, 18, 5, 14, 17],
                    position_lvl_id: [],
                    id: []
                },
                HireDate: {
                    role_id: [2, 4, 18, 5, 14, 17],
                    position_lvl_id: [],
                    id: []
                },
                workOrderFilter: {
                    role_id: [2, 9, 10],
                    position_lvl_id: [],
                    id: []
                },
                locomechanic: {
                    role_id: [11],
                    position_lvl_id: [],
                    id: []
                },


            },
            employeeInfo: {
                dateOfBirth: {
                    role_id: [2, 14],
                    position_lvl_id: [],
                    // id: [10027]
                    id: []
                },
                phoneNumber: {
                    role_id: [2, 5, 14, 17],
                    position_lvl_id: [],
                    id: []
                },
                ssnEdit: {
                    role_id: [5, 14, 17],
                    position_lvl_id: [],
                    id: []
                },
                ssn: {
                    role_id: [2, 4, 18, 5, 14, 7, 17],
                    position_lvl_id: [],
                    id: []
                },
                emergencyContact: {
                    role_id: [2, 5, 14],
                    position_lvl_id: [],
                    id: []
                },
                hireDate: {
                    role_id: [2],
                    position_lvl_id: [],
                    id: []
                },
                terminationDate: {
                    role_id: [2],
                    position_lvl_id: [],
                    id: []
                },

            }
        },
        newHireQueue: {
            createEmployeeRecord: {
                role_id: [2, 14],
                position_lvl_id: [],
                // id: [10027]
                id: []
            },
            createEmployeeRecord2: {
                role_id: [2, 14],
                position_lvl_id: [],
                id: []
            },
            changePassword: {
                role_id: [2, 14],
            },
            closeApplicant: {
                role_id: [14],
            }
        },
        safetyTesting: {
            incident: {
                role_id: [2, 7, 15, 16],
                position_lvl_id: [],
                // id: [10032, 10675]
                id: []
            },
            Audit: {
                role_id: [2, 15, 16, 19],
                position_lvl_id: [],
                // id: [10032, 10675]
                id: []
            },
            EnterAudit: {
                role_id: [2, 12, 15, 16, 19],
                position_lvl_id: [],
                // id: [10032, 10675]
                id: []
            },
            EnterAuditEvaluator: {
                role_id: [2, 15, 16],
                position_lvl_id: [],
                id: []
            },
            checkRide: {
                role_id: [2, 6, 15, 16, 7, 12, 13],
                position_lvl_id: [],
                id: []
            },
            testEvent: {
                role_id: [2, 6, 15, 16, 7, 9, 10, 12, 13, 10],
                position_lvl_id: [],
                id: []
            },
            Createincident: {
                role_id: [2, 7, 15, 16],
                position_lvl_id: [],
                // id: [10032, 10675]
                id: []
            },
            CreatecheckRide: {
                role_id: [2, 6, 15, 16, 7, 12, 13],
                position_lvl_id: [],
                id: []
            },
            CreatetestEvent: {
                role_id: [2, 6, 15, 16, 7, 9, 10, 12, 13, 10],
                position_lvl_id: [],
                id: []
            },
        },
        locomotive: {
            lookupEdit: {
                equipID: {
                    role_id: [9, 2],
                    position_lvl_id: [],
                    id: []
                },
                DataSheet: {
                    role_id: [9, 2, 10],
                    position_lvl_id: [],
                    id: []
                },
                fra: {
                    role_id: [9, 2],
                    position_lvl_id: [],
                    id: []
                },
                year_built: {
                    role_id: [9, 2],
                    position_lvl_id: [],
                    id: []
                },
                location: {
                    role_id: [9, 2],
                    position_lvl_id: [],
                    id: []
                },
                status: {
                    role_id: [9, 2],
                    position_lvl_id: [],
                    id: []
                },
                lease: {
                    role_id: [9, 2],
                    position_lvl_id: [],
                    id: []
                },
                leaseView: {
                    role_id: [9, 2],
                    position_lvl_id: [],
                    id: []
                },

                Addlocmotive: {
                    role_id: [9, 2, 10],
                    position_lvl_id: [],
                    id: []
                },
                accountingJob: {
                    role_id: [9, 2],
                    position_lvl_id: [],
                    id: []
                },
                addNotes: {
                    role_id: [9, 2, 10],
                    position_lvl_id: [],
                    id: []
                },
                addContact: {
                    role_id: [9, 2, 10],
                    position_lvl_id: [],
                    id: []
                },
                deleteContract: {
                    role_id: [9, 2],
                    position_lvl_id: [],
                    id: []
                },
                backDate: {
                    role_id: [2, 9],
                    position_lvl_id: [],
                    id: []
                },
                oos_code: {
                    role_id: [2, 9],
                    position_lvl_id: [],
                    id: []
                },
            },
            TicketEdit: {
                CategoryEdit: {
                    role_id: [9, 2, 10],
                    position_lvl_id: [],
                    id: []
                },

                TableEdit: {
                    role_id: [2, 9, 10],
                    position_lvl_id: [],
                    id: []
                },


            },
        },
        custom_conditions: {
            system_loco_admin: {
                role_id: [2, 9]
            },
            check_ride_select_filter: {
                role_id: [12, 2, 15, 16 , 20]
            }
        }
    }

    let permission = null;
    if (innerComponent) {
        if (subInnerComponent) {
            permission = capabilities[component]?.[innerComponent]?.[subInnerComponent];
        }
        else {
            permission = capabilities[component]?.[innerComponent]
        }

    } else {
        permission = capabilities[component]
    }
    if (permission) {
        let check1 = role_id?.some(id => permission?.role_id?.includes(id));
        let check2 = permission?.id?.includes(id)
        let check3 = permission?.position_lvl_id?.includes(PositionLevelId)
        return check1 || check2 || check3
    }

    return false;
}

export default roleManager








